import type { Stage } from "./types";
import puzzleData from "../data/puzzles.json";

/**
 * Puzzle mode (idea #8): handcrafted stages with pre-filled boards, tight drop
 * limits, and deterministic spawn queues (the engine seed is fixed per puzzle,
 * so every player sees the identical board AND queue — solutions are shareable).
 */
export const PUZZLES: readonly Stage[] = puzzleData as unknown as Stage[];

const BY_ID = new Map<string, Stage>(PUZZLES.map((p) => [p.id, p]));

export function getPuzzle(id: string): Stage | undefined {
  return BY_ID.get(id);
}

export function isPuzzleId(id: string): boolean {
  return BY_ID.has(id);
}

/** Next puzzle in order, or undefined after the last one. */
export function nextPuzzleId(id: string): string | undefined {
  const i = PUZZLES.findIndex((p) => p.id === id);
  if (i < 0 || i + 1 >= PUZZLES.length) return undefined;
  return PUZZLES[i + 1].id;
}

/** Fixed engine seed for a puzzle — the queue is part of the puzzle design. */
export function puzzleSeed(id: string): string {
  return `puzzle-${id}`;
}

/** Deterministic "puzzle of the day" rotation (same pick for everyone). */
export function dailyPuzzleId(dateKey: string): string {
  let h = 2166136261;
  for (const ch of dateKey) {
    h ^= ch.charCodeAt(0);
    h = Math.imul(h, 16777619);
  }
  return PUZZLES[(h >>> 0) % PUZZLES.length].id;
}
